"use strict";
// @ts-ignore
try {
    self['workbox:expiration:6.1.5'] && _();
}
catch (e) { }
